"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterplanetaryCinematicsBot = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
class InterplanetaryCinematicsBot extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.INTERPLANETARY_CINEMATICS_BOT,
            startingMegaCredits: 0,
            metadata: {
                cardNumber: 'AU11',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect('When this bot resolves an Event tag, it takes an extra action.', (eb) => {
                            eb.event().played.startEffect.arrow(Size_1.Size.LARGE).asterix();
                        });
                        ce.vSpace();
                        ce.action('Gain 1 TR.', (eb) => {
                            eb.empty().startAction.tr(1);
                        });
                        ce.vSpace();
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    initialAction() {
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const game = player.game;
        game.automaBotVictoryPointsBreakdown.terraformRating++;
        game.log('${0} action: Gain 1 TR and take an extra action', (b) => b.card(this));
        return undefined;
    }
}
exports.InterplanetaryCinematicsBot = InterplanetaryCinematicsBot;
//# sourceMappingURL=InterplanetaryCinematicsBot.js.map